import { ActionCompleteResponse, ApiSuccess } from 'common/types/ApiResponse';

export function isActionCompleteSuccess<D>(
  response: ActionCompleteResponse<D> | null
): response is ApiSuccess<D> {
  return Boolean(
    response && response.payload && response.payload.responseCode === 'SUCCESS'
  );
}
